import React from "react";

// import burgerLogo from '../../assets/images/burger-logo.png';
import classes from "./Logo.css";
import logo_image from "../../img/logo.jpg";

const logo = props => (
  <img
    src={logo_image}
    alt="AKCENTBUD"
    className="img-fluid"
    height="50px"
    width="50px"
  />
);

export default logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js